import { App } from 'antd'

export function useAppMessages() {
  const { message } = App.useApp()

  return message
}
